import AbstractProductType from './AbstractProductType'
import { ProductTypeFormat } from './types'

export default class ValetRooftop extends AbstractProductType {

  name = 'valet_rooftop'
  title = 'Valet Rooftop'

  valet = true

  format = ProductTypeFormat.Rooftop

}
